import { render, staticRenderFns } from "./book.edit.vue?vue&type=template&id=0ebe7a87&scoped=true"
import script from "./book.edit.vue?vue&type=script&lang=js"
export * from "./book.edit.vue?vue&type=script&lang=js"
import style0 from "./book.edit.vue?vue&type=style&index=0&id=0ebe7a87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebe7a87",
  null
  
)

export default component.exports